<template>
  <div
    class="d-flex align-items-center justify-content-center position-relative h-100 w-100"
  >
    <video class="video-bg" id="video-element1" autoplay muted loop>
      <source
        src="~@/assets/images/pages/login/BG_Login.mp4"
        type="video/mp4"
      />
    </video>
    <div class="content-login">
      <div class="container">
        <div class="row">
          <div class="col-12">
            <div
              class="text-header font-large-1 text-bold text-black text-center mt-3"
            >
              Verify OTP password on your phone.
            </div>
          </div>
          <div class="col-12">
            <div class="text-detail text-center">
              <div class="font-medium-5">
                <span class="text-muted"
                  >Please enter the OTP code received via SMS at
                </span>
                <span class="text-black text-bold"
                  ><span>{{ formData.mobileCountryCodeStr }} </span>
                  <span>{{ formData.mobileNo }}</span>
                </span>
              </div>
              <div class="font-medium-5" v-if="formData.isContdown">
                <span class="text-muted">Didn't receive OTP code? </span>
                <span class="text-black text-bold">Request again in </span>
                <span class="text-black text-bold">{{ resolveTimer }} </span>
              </div>
              <div class="font-medium-5" v-else>
                <button type="button" class="btn btn-link" @click="onResendOTP">
                  <span class="text-primary font-medium-5"><u>Resend</u></span>
                </button>
              </div>
              <div class="font-medium-5 mt-1" v-if="formData.error">
                <div class="text-center">
                  <span class="text-danger font-medium-5">{{
                    formData.errorMsg
                  }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row otp-input-margin">
          <div class="col">
            <div class="m-auto">
              <b-form id="change-password" @submit.prevent="() => {}">
                <div class="font-medium-5 text-pad text-muted">
                  <span>Ref. </span>
                  <span>{{ formData.otpRef }}</span>
                </div>
                <div class="container text-center">
                  <div class="otp-input">
                    <input
                      class="otp-input-field text-center font-large-3 mr-3"
                      type="text"
                      id="otp-first-index"
                      maxlength="1"
                      autocomplete="off"
                      @input="(event) => onInputNumber(event)"
                      @keyup="(event) => onKeyUp(event)"
                      @keypress="(event) => onKeyPress(event)"
                    />
                    <input
                      class="otp-input-field text-center font-large-3 mr-3"
                      type="text"
                      id="otp-sec-index"
                      maxlength="1"
                      autocomplete="off"
                      @input="(event) => onInputNumber(event)"
                      @keyup="(event) => onKeyUp(event)"
                      @keypress="(event) => onKeyPress(event)"
                    />
                    <input
                      class="otp-input-field text-center font-large-3 mr-3"
                      type="text"
                      id="otp-third-index"
                      maxlength="1"
                      autocomplete="off"
                      @input="(event) => onInputNumber(event)"
                      @keyup="(event) => onKeyUp(event)"
                      @keypress="(event) => onKeyPress(event)"
                    />
                    <input
                      class="otp-input-field text-center font-large-3 mr-3"
                      type="text"
                      id="otp-fourth-index"
                      maxlength="1"
                      autocomplete="off"
                      @input="(event) => onInputNumber(event)"
                      @keyup="(event) => onKeyUp(event)"
                      @keypress="(event) => onKeyPress(event)"
                    />
                    <input
                      class="otp-input-field text-center font-large-3 mr-3"
                      type="text"
                      id="otp-fifth-index"
                      maxlength="1"
                      autocomplete="off"
                      @input="(event) => onInputNumber(event)"
                      @keyup="(event) => onKeyUp(event)"
                      @keypress="(event) => onKeyPress(event)"
                    />
                    <input
                      class="otp-input-field text-center font-large-3 mr-3"
                      type="text"
                      id="otp-sixth-index"
                      maxlength="1"
                      autocomplete="off"
                      @input="(event) => onInputNumber(event)"
                      @keyup="(event) => onKeyUp(event)"
                      @keypress="(event) => onKeyPress(event)"
                    />
                  </div>
                </div>
              </b-form>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="copyright mt-1 mb-1">
      <img :src="logoChoco" width="150" class="logo-choco" />
    </div>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from "vee-validate";
import VuexyLogo from "@core/layouts/components/Logo.vue";
import logoChoco from "@/assets/images/logo/logo-choco.png";
import {
  BRow,
  BCol,
  BLink,
  BFormGroup,
  BFormInput,
  BInputGroupAppend,
  BInputGroupPrepend,
  BInputGroup,
  BFormCheckbox,
  BCardText,
  BCardTitle,
  BImg,
  BForm,
  BButton,
  BAlert,
  VBTooltip,
  BIconPersonPlus,
} from "bootstrap-vue";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";

import useLoginAction from "@/views/pages/authentication/login/hooks/useLoginAction";
import { required, email, password } from "@validations";

import {
  getCurrentInstance,
  reactive,
  computed,
  onBeforeMount,
  onMounted,
  ref,
  watch,
  onUpdated,
} from "@vue/composition-api";
import useSetTimeInterval from "@/utils/hooks/useSetTimeInterval";

export default {
  props: {
    requestOTPData: null,
    errorData: null,
    isResendOTP: false,
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroupPrepend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BAlert,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
    vSelect,
  },
  directives: {
    "b-tooltip": VBTooltip,
    Ripple,
  },

  setup(props, { emit }) {
    const formData = reactive({
      mobileNo: null,
      mobileCountryCode: null,
      mobileCountryCodeStr: null,
      expTime: null,
      otpRef: null,
      txRef: null,
      providerRef: null,
      brandRef: null,
      otpCode: null,
      userName: null,
      password: null,
      error: false,
      errorMsg: null,
      timer: { days: 0, hours: 0, minutes: 0, seconds: 0 },
      timerStr: null,
      isContdown: false,
      expTimeSec: null,
    });

    const initFormData = () => {
      formData.error = false;
      formData.errorMsg = "";
      return new Promise((resolve, reject) => {
        const inputs = document.querySelectorAll("input.otp-input-field");
        const inputList = [...inputs];

        inputList.map((input) => {
          input.classList.remove("border-danger");
        });

        if (props.requestOTPData) {
          formData.mobileNo = props.requestOTPData.mobileNo;
          formData.mobileCountryCode =
            props.requestOTPData.mobileCountry.countryData.phoneCode;
          formData.mobileCountryCodeStr =
            props.requestOTPData.mobileCountry.value;
          formData.expTime = props.requestOTPData.expire_dt;
          formData.expTimeSec = props.requestOTPData.expire_in_second;
          formData.otpRef = props.requestOTPData.otp_ref;
          formData.txRef = props.requestOTPData.txrefernce;
          formData.providerRef = props.requestOTPData.providerRef;
          formData.brandRef = props.requestOTPData.brandRef;
        }
        if (props.errorData) {
          let errStr = "Expired or Invalid OTP";
          if (props.errorData.message) errStr = props.errorData.message;
          else if (props.errorData.system) errStr = props.errorData.system;

          formData.error = true;
          formData.errorMsg = errStr + ", please try again.";

          inputList.map((input) => {
            input.classList.add("border-danger");
            input.value = "";
          });
        }

        resolve();
      });
    };

    const onKeyUp = (current) => {
      formData.error = false;
      formData.errorMsg = "";
      const inputs = document.querySelectorAll("input.otp-input-field");
      const inputList = [...inputs];
      inputList.map((input) => {
        input.classList.remove("border-danger");
      });
      let currentInput = current.target;
      let nextInput = current.target.nextElementSibling;
      let prevInput = current.target.previousElementSibling;

      if (current.key == "ArrowRight") {
        if (nextInput) document.getElementById(nextInput.id).focus();
      } else if (current.key == "ArrowLeft") {
        if (prevInput) document.getElementById(prevInput.id).focus();
      } else if (current.key == "Backspace") {
        if (prevInput) document.getElementById(prevInput.id).focus();
      } else {
        if (currentInput.value.length) {
          if (current.charCode >= 48 && current.charCode <= 57) {
            document.getElementById(currentInput.id).value = current.key;
          }

          if (!nextInput) {
            document.getElementById(currentInput.id).blur();
          } else {
            document.getElementById(nextInput.id).focus();
          }
          onSubmit();
        }
      }
    };

    const onInputNumber = (current) => {
      let currentInput = current.target;

      document.getElementById(
        currentInput.id
      ).value = currentInput.value.replace(/\D/g, "");
    };

    const onKeyPress = (current) => {
      let currentInput = current.target;
      if (current.charCode >= 48 && current.charCode <= 57) {
        document.getElementById(currentInput.id).value = current.key;
      }
    };

    const onResendOTP = () => {
      emit("onResendOTP", formData);
    };

    const onSubmit = () => {
      const inputs = document.querySelectorAll("input.otp-input-field");
      const inputList = [...inputs];
      let otpStr = "";

      inputList.map((input) => {
        otpStr += input.value;
      });

      if (otpStr.length < 6) return;

      formData.otpCode = otpStr;
      formData.userName = "" + formData.mobileCountryCode + formData.mobileNo;
      formData.password = formData.otpCode + "," + formData.otpRef;
      emit("onSubmit", formData);
    };

    const resolveTimer = computed(() => {
      let dayStr = "";
      let hourStr = "";
      let minStr = "";
      let secStr = "";

      if (formData.timer) {
        if (formData.timer.days > 0)
          dayStr = `${parseInt(formData.timer.days)}d `;
        if (formData.timer.hours > 0)
          hourStr = `${parseInt(formData.timer.hours)}h `;
        if (formData.timer.minutes > 0)
          minStr = `${parseInt(formData.timer.minutes)}m `;
        if (formData.timer.seconds > 0)
          secStr = `${parseInt(formData.timer.seconds)}s `;
      }

      formData.timerStr = dayStr + hourStr + minStr + secStr;

      return formData.timerStr;
    });

    const onSetTimer = async (dt) => {
      let dateTime = dt || new Date();
      return new Promise((resolve, reject) => {
        // Set the date we're counting down to
        var countDownDate = new Date(dateTime).getTime();
        // Update the count down every 1 second
        var interval = setInterval(async () => {
          // Get today's date and time
          var now = new Date().getTime();
          // Find the distance between now and the count down date
          var distance = countDownDate - now;
          // Time calculations for days, hours, minutes and seconds
          var days = Math.floor(distance / (1000 * 60 * 60 * 24));
          var hours = Math.floor(
            (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
          );
          var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
          var seconds = Math.floor((distance % (1000 * 60)) / 1000);

          let timerObj = {
            days: days,
            hours: hours,
            minutes: minutes,
            seconds: seconds,
          };
          formData.isContdown = true;
          formData.timer = timerObj;

          // If the count down is finished
          if (distance <= 1) {
            formData.timer = null;
            formData.isContdown = false;
            clearInterval(interval);
          }
        }, 1000);
      });
    };

    onBeforeMount(() => {
      initFormData().then(() => {
        let date = new Date(formData.expTime);
        onSetTimer(date);
      });
    });

    onMounted(() => {
      document.getElementById("otp-first-index").focus();
    });

    watch(
      props,
      () => {
        initFormData().then(() => {
          document.getElementById("otp-first-index").focus();
          if (props.isResendOTP == true) {
            let date = new Date();
            date.setSeconds(date.getSeconds() + formData.expTimeSec);
            onSetTimer(date);
          }
        });
      },
      { deep: true }
    );

    return {
      formData,
      onKeyUp,
      onResendOTP,
      onInputNumber,
      onKeyPress,
      resolveTimer,
      logoChoco,
    };
  },
};
</script>

<style scoped lang="scss">
@import "~@/assets/css/override-styles/v-select.css";
@import "~@/assets/css/pages/login/login.css";
@import "~@/assets/css/override-styles/dynamic-fields.css";

.text-header {
  //border-bottom: 1px solid #dedede;
  padding: 1rem;
}

.content-policy {
  background-color: #f2f5f5;
  border: 1px solid #e8e8e8;
  border-radius: 10px;
}

.content-login {
  width: 700px;
  height: auto;
  display: flex;
  /* overflow: hidden; */
  z-index: 1;
}

.text-pad {
  padding: 0 5.5rem;
}

.otp-input-margin {
  margin: 5rem 0 8rem 0;
}

.otp-input-field {
  width: 70px;
  height: 80px;
  border-radius: 5px;
  border: 1px solid;
  background-color: #f7f7f7;
}

.text-primary {
  color: #007fff !important;
}
</style>
